import { Card, CardContent, Typography, Box } from "@mui/material";
import React, { useState } from "react";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import VisibilityIcon from "@mui/icons-material/Visibility";

const EPISODE_HEIGHT = 100;

const EpisodeList = ({ episodes, onSelect, activeEpisode }) => {
  return (
    <Box
      sx={{
        height: "100%",
        overflowY: "auto",
        display: "flex",
        flexDirection: "column",
        gap: 1,
        pr: 1,
      }}
    >
      {episodes?.map((ep, i) => {
        const isActive = activeEpisode?.title === ep.title;

        return (
          <Card
            key={i}
            onClick={() => {
              onSelect(ep);
            }}
            sx={{
              height: EPISODE_HEIGHT,
              display: "flex",
              alignItems: "center",
              gap: 2,
              px: 1.5,
              cursor: "pointer",
              backgroundColor: isActive ? "#F9F2FF" : "#2A0B45",
              color: isActive ? "#000" : "#fff",
              borderRadius: 0,
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                width: 140,
                height: 70,
                position: "relative",
                borderRadius: 0,
                overflow: "hidden",
                flexShrink: 0,
              }}
            >
              <img
                src={ep.thumbnail}
                alt={ep.title}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  filter: "brightness(0.5)",
                }}
              />

              <Box
                sx={{
                  position: "absolute",
                  inset: 0,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    backgroundColor: "#A100FF",
                    // borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <PlayArrowIcon sx={{ color: "#fff", fontSize: 18 }} />
                </Box>
              </Box>
            </Box>

            {/* Content */}
            <CardContent
              sx={{
                p: 0,
                flex: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-evenly",
              }}
            >
              <Typography
                sx={{
                  fontSize: 13,
                  fontWeight: 600,
                  lineHeight: 1.1,
                  mt: 0.7,
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {ep.title}
              </Typography>

              <Typography
                sx={{
                  fontSize: 12,
                  color: isActive ? "#555" : "#ddd",
                  lineHeight: 1.4,
                  mt: 0.2,
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {ep.description}
              </Typography>

              {/* Footer */}
              <Box
                sx={{
                  mt: 0.5,
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    fontSize: 11,
                    fontWeight: 600,
                    color: isActive ? "#A100FF" : "#ccc",
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                >
                  <AccessTimeIcon sx={{ fontSize: 14 }} />
                  {isActive ? "Now Playing" : ep.duration}
                </Typography>

                <Typography
                  sx={{
                    fontSize: 11,
                    color: "#999",
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                  }}
                ></Typography>
              </Box>
            </CardContent>
          </Card>
        );
      })}
    </Box>
  );
};

export default EpisodeList;
